<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(dataInizio)="{ item }">
                        {{ formatDate(item.dataInizio) }}
                    </template>
                    <template v-slot:cell(dataFine)="{ item }">
                        {{ formatDate(item.dataFine) }}
                    </template>
                    <template v-slot:cell(actions)="{ item }">
                        <b-container class="bv-example-row">
                            <b-button size="sm" variant="btn btn-outline-secondary waves-effect waves-light width-sm no-text" @click="onClickViewProgetto(item)">
                                <font-awesome-icon icon="eye"> </font-awesome-icon>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Modifica" variant="outline-success" @click="onClickEditProgetto(item)">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <pazienti-progetti-modal-edit-component ref="PazientiProgettiModalEditComponent" @onSaveParametroVitale="onParametroVitaleSave" @deleteParametroVitale="onParametroVitaleDelete" @onCloseModal="loadData" />
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import PazientiProgettiModalEditComponent from "./PazientiProgettiModalEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { PazientiProgettiModalEditComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/pazientiprogetti",
            filtro: {},
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "Nome",
                    key: "nome",
                    sortable: true,
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                },
                {
                    label: "Data Fien",
                    key: "dataFine",
                    sortable: true,
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtro"]) {
            me.filtro = JSON.parse(sessionStorage["filtro"]);
        }
        // me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.items = response.data.data.list;
                    me.rows = response.data.data.recordsNumber;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onClickNuovoProgetto() {
            let me = this;
            me.$refs.PazientiProgettiModalEditComponent.setId(null);
        },
        onClickViewProgetto(item) {
            this.$router.push("/progettipazienti/view/" + item.id);
        },
        onClickEditProgetto(item) {
            let me = this;
            me.$refs.PazientiProgettiModalEditComponent.setId(item.id);
        },
        onParametroVitaleSave() {
            let me = this;
            me.loadData();
        },

        onParametroVitaleDelete() {
            let me = this;
            me.loadData();
        },

        onCloseModalParametroVitale() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style></style>
